import { atom } from "recoil";

export const cisIdList = atom({
  key: "cisIdList",
  default: null,
});
